export default __webpack_public_path__ + "static/media/linkIcon-complete.6c3ef208.svg";